{{#if config.switch}}
  {{> elements/_switch }}
{{else}}
  {{> elements/_checkbox }}
{{/if}}
